export default __webpack_public_path__ + "4249277d1564eb2a660e736c06b3febc.svg";